import React from "react";
import { Checkbox, Icon, Label, Table } from "semantic-ui-react";
import { formatCurrency } from "../helpers/currency";
import {
  convertSecondsToISOTime,
  getDatePart,
  getTimePart,
} from "../helpers/datetime";

const ComplianceAlertTableRow = ({
  record,
  selectedAlerts,
  onAlertClick,
  handleSelect,
}) => {
  const showName = (record) => {
    let fullName = "";
    let forename = "";
    let surname = "";
    if (!record.customer) {
      fullName = "-";
    } else {
      forename = record.customer.forename;
      surname = record.customer.surname;
      if (forename && surname) {
        fullName = `${forename} ${surname}`;
      } else if (forename) {
        fullName = forename;
      } else if (surname) {
        fullName = surname;
      } else {
        fullName = "-";
      }      
    }
    return fullName;
  };
  return (
    <Table.Row
      key={record.id}
      className="cursor-pointer"
      onClick={() => onAlertClick(record)}
    >
      <Table.Cell
        textAlign="center"
        onClick={(e) => {
          handleSelect(e, record.id);
        }}
      >
        <Checkbox
          checked={selectedAlerts.includes(record.id)}
          onChange={(event) => {
            handleSelect(event, record.id);
          }}
        />
      </Table.Cell>
      <Table.Cell className="text-sm">
        {getDatePart(record.alertTime)} {getTimePart(record.alertTime)}
      </Table.Cell>
      <Table.Cell className="text-sm">{record.alertType.name}</Table.Cell>
      {/* <Table.Cell className="text-sm" textAlign="center">
        {showName(record)}
      </Table.Cell>
      <Table.Cell className="text-sm" textAlign="center">
        {record.estimatedAge === null ? "-" : record.estimatedAge}
      </Table.Cell> */}
      <Table.Cell>
        <Label className="text-sm" textAlign="center">{record.positionNumber || "-"}</Label>
      </Table.Cell>
      <Table.Cell>
        <Label className="text-sm" textAlign="center">{record.machineInstallationNumber || "-"}</Label>
      </Table.Cell>
      <Table.Cell className="text-sm" textAlign="center">
        {formatCurrency(record.netLoss)}
      </Table.Cell>
      <Table.Cell className="text-sm" textAlign="center">
        {convertSecondsToISOTime(record.timeOnGame)}
      </Table.Cell>
      <Table.Cell className="text-sm" textAlign="center">
        {formatCurrency(record.spend)}
      </Table.Cell>
      <Table.Cell className="text-sm" textAlign="center">
        <Icon
          name={record.active ? "check" : "close"}
          color={record.active ? "green" : "red"}
        />
      </Table.Cell>
    </Table.Row>
  );
};

export default ComplianceAlertTableRow;
